import { useSelector } from 'react-redux';

const useLeasingValue = (type) => {
    const { builderData } = useSelector(state => state.data);
    const { leasing = {}, exteriors = [] } = builderData;
    const { colorCode, leasingPeriod, leasingMileage, leasingTyres, leasingInsurance } = useSelector(state => state.config);

    const period = leasing.period?.find(item => item.value === leasingPeriod) || {};
    const mileage = period.mileage || [];

    const periodValue = period.value || null;
    const mileageValue = leasingMileage || null;
    const twotoneValue = period.pearlTwoTone?.price || 0;
    const metallicValue = period.metallicColor?.price || 0;
    const tyresValue = period.winterTyres?.price || 0;
    const insuranceValue = period.greenvalInsurance?.price || 0;

    const mileagePrice = mileage.find(item => item.value === leasingMileage)?.price || 0;
    const colorPrice = exteriors.find(item => item.code === colorCode)?.leasingPrice || 0;
    const tyresPrice = leasingTyres ? tyresValue : 0;
    const insurancePrice = leasingInsurance ? insuranceValue : 0;

    return {
        mileagePrice,
        colorPrice,
        tyresPrice,
        insurancePrice,
        periodValue,
        mileageValue,
        twotoneValue,
        metallicValue,
        tyresValue,
        insuranceValue
    };
};

export default useLeasingValue;